import styled from 'styled-components';
import { colors } from '../../styles/colors';
import { Button } from '../Button';
import { DIALOG_RADIUS } from './styles';

// Conteúdo da variante "dialog". O padding fica no ModalWindow; aqui só o espaçamento entre blocos.
export const Dialog = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap ?? 20}px;
`;

export const DialogHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DialogTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: ${colors.Black};
`;

export const DialogText = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: ${colors.text['sub-500']};
`;

export const DialogHelpText = styled.span`
  font-size: 12px;
  line-height: 1.4;
  color: ${colors.text['sub-500']};
`;

export const DialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const DialogButton = styled(Button)`
  width: auto;
  padding: 10px 16px;
  border-radius: ${DIALOG_RADIUS}px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.6;
  text-transform: uppercase;
`;
